import { DataGridPremium, GridEventListener, useGridApiRef, useKeepGroupedColumnsHidden } from "@mui/x-data-grid-premium"
import StyledCard from "components/UI/StyledCard"
import { toDollars } from "lib/utils";
import React from "react";


export default {
  title: 'Components/DataGridExamples',
  component: DataGridPremium,
}


const Template = (args) => {
  const apiRef = useGridApiRef()
  const initialState = useKeepGroupedColumnsHidden({
    apiRef,
    initialState: {
      rowGrouping: {
        model: ['month']
      },
      columns: {
        // Other hidden columns
        columnVisibilityModel: { month: false },
      },
      aggregation: {
        model: {
          billableLeads: 'sum',
          total: 'sum',
        },
      },
    },
  });

  // React.useEffect(() => {
  //   return apiRef.current.subscribeEvent('rowExpansionChange', (params) => {
  //     if (params.childrenExpanded) {
  //       apiRef.current.autosizeColumns({ includeOutliers: true, expand: true });
  //     }
  //   });
  // }, [apiRef]);

  const onRowClick = React.useCallback<GridEventListener<'rowClick'>>(
    (params) => {
      const rowNode = apiRef.current.getRowNode(params.id);
      if (rowNode && rowNode.type === 'group') {
        apiRef.current.setRowChildrenExpansion(params.id, !rowNode.childrenExpanded);
      }
    },
    [apiRef],
  );

  return (
    <StyledCard
      title='Invoice History'
      note='Billable lead count and CPL Drafts read to be sent to vendors for invoice request.'
      controls={[]}
      isSubsection
      hasStickyHeader
      role="group"
    >
      <DataGridPremium
        {...args}
        apiRef={apiRef}
        initialState={initialState}
        onRowClick={onRowClick}
      />
    </StyledCard>
  )
}

export const Default = Template.bind({})
Default.args = {
  title: "Sample Table",
  groupingColDef:{ width: 250 },
  columns: [
    {
      headerName: "Month",
      field: "month",
      type: "string",
      flex: 1,
    },
    {
      headerName: "Vendor Name",
      field: "vendorName",
      type: "string",
      flex: 1,
    },
    {
      headerName: "Status",
      field: "status",
      type: "string",
      flex: 1,
    },
    {
      headerName: "Billable Leads",
      field: "billableLeads",
      type: "number",
      flex: 1,
    },
    {
      headerName: "CPL",
      field: "cplInCents",
      type: "number",
      valueFormatter: (value) => value ? toDollars(Number(value)) : '—',
      flex: 1,
    },
    {
      headerName: "Total",
      field: "total",
      type: "number",
      valueGetter: (value, row) => {
        if (!row.billableLeads || !row.cplInCents) {
          return null;
        }
        return row.billableLeads * row.cplInCents;
      },
      valueFormatter: (value) => toDollars(Number(value)),
      headerClassName: 'last-column--header',
      cellClassName: 'last-column--cell',
      flex: 1,
    },
  ],
  rows: [
    { id: 1, month: 'September 2024', vendorName: 'Cygnus Education, Inc.', status: 'Draft', billableLeads: 30, cplInCents: 2500 },
    { id: 2, month: 'September 2024', vendorName: 'Education Station', status: 'Draft', billableLeads: 88, cplInCents: 1500 },
    { id: 3, month: 'September 2024', vendorName: 'Leads R Us', status: 'Draft', billableLeads: 20, cplInCents: 8000 },
    { id: 4, month: 'September 2024', vendorName: 'MarketMe, Inc.', status: 'Draft', billableLeads: 60, cplInCents: 20000 },
    { id: 5, month: 'August 2024', vendorName: 'Cygnus Education, Inc.', status: 'Sent', date: 'Sep. 5, 2024', billableLeads: 198, cplInCents: 7900 },
    { id: 6, month: 'August 2024', vendorName: 'Education Station', status: 'Sent', date: 'Sep. 3, 2024',  billableLeads: 30, cplInCents: 2500 },
    { id: 7, month: 'August 2024', vendorName: 'Leads R Us', status: 'Sent', date: 'Sep. 1, 2024',  billableLeads: 88, cplInCents: 1500 },
    { id: 8, month: 'August 2024', vendorName: 'MarketMe, Inc.', status: 'Sent', date: 'Sep. 1, 2024',  billableLeads: 20, cplInCents: 8000 },
  ],
}
